import React from "react";
import { FormControlLabel, Checkbox, Divider } from "@mui/material";
import { CheckboxSection, FieldGroupTitle, CheckboxGroup as StyledCheckboxGroup } from "./styles";
import type { FieldGroup } from "../../types";

interface CheckboxGroupProps extends FieldGroup {}

export const CheckboxGroup = ({
  title,
  options,
  selectedValues,
  onChangeHandler,
  isLast = false,
}: CheckboxGroupProps) => {
  return (
    <CheckboxSection>
      {title && <FieldGroupTitle>{title}</FieldGroupTitle>}

      <StyledCheckboxGroup>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            control={
              <Checkbox
                size="small"
                checked={selectedValues.includes(option.value)}
                onChange={(e) => onChangeHandler(option.value, e.target.checked)}
              />
            }
            label={option.label}
          />
        ))}
      </StyledCheckboxGroup>

      {!isLast && <Divider style={{ margin: "16px 0" }} />}
    </CheckboxSection>
  );
};
